import api from '@/common/api';
import RouteKey from '@/common/RouteKey';
// import ApplyTypeHelper from '@/common/ApplyTypeHelper';
import { str2Int, CompareFunc } from '@/common/utils';
import FormItemUploadFile from '../common/FormItemUploadFile';
import { OptionMapper, KeyEnum } from '@/common/OptionConstant';
import MessageType from '@/components/common/message-box/MessageType';
import ErrorHandler from './ErrorHandler';
import { backwardSupportValidate } from '@/common/ValidationUtils';
import Bubble from '../common/Bubble';
import tipConstant from '../data/TipConstant';
const JoinwayType = KeyEnum.JoinWay;
const ApplyType = {
  TEST: 1,
  PRO: 2
};
const ConfirmMessage = {
  [ApplyType.TEST]: '请确保所填写信息的准确性',
  [ApplyType.PRO]: '申请正式授权前请确保已和优图谈好合作方案'
};
const Labletext = {
  [KeyEnum.JoinWay.INTERNAL]: '合作备案',
  [KeyEnum.JoinWay.EXTERNAL]: '合同文件'
};
const TENCENT_INNER_PROPS = [
  'productids',
  // 'ip',
  'scene',
  'authtype',
  'machinetype',
  'scope',
  'applytype',

  'ytcontact',
  'intdept',
  'peercontact',
  'mailreceiver'
];
const TENCENT_EXTERNAL_PROPS = [
  'productids',
  // 'ip',
  'scene',
  'authtype',
  'machinetype',
  'scope',
  'applytype',

  'extname',
  'exturl',
  'ytcontact',
  'peercontact',
  'mailreceiver'
];
const IS_SUCCESS = 'is-success';
const IS_ERROR = 'is-error';
const SHOW_SDK_1 = 'YtOpen';
const DISABLED_SDK = 'Local';
const SERVICE_TYPE = 'service/centos';
export default {
  name: 'PrivateCreator',
  components: {
    FormItemUploadFile,
    Bubble
  },
  data() {
    return {
      tipConstant,
      validateFileLicence: false,
      validateFileContract: false,
      ErrorNameLicence: 'LICENCE',
      ErrorNameContract: 'CONTRACT',
      defaultExternal: true,
      showInnerTable: false,
      OptionMapper,
      JoinwayType,
      ApplyType,
      contractText: Labletext[JoinwayType.EXTERNAL],
      validateLicenceFileResult: {
        file: null,
        legal: false
      },
      validateContractFileResult: {
        file: null,
        legal: false
      },
      newPrivateData: {
        productids: [],
        // ip: '',
        scene: '',
        authtype: '',
        machinetype: '',
        scope: '',
        applytype: '',
        ytcontact: '',
        intdept: '',
        peercontact: '',
        exturl: '',
        extname: '',
        mailreceiver: ''
      },
      rules: {
        productids: [
          {
            type: 'array',
            required: true,
            message: '请选择服务类型',
            trigger: 'change'
          }
        ],
        scene: [
          {
            type: 'string',
            required: true,
            message: '请输入应用场景',
            trigger: 'change'
          }, {
            max: 600,
            message: '不超过600字',
            trigger: 'change'
          }, {
            validator: backwardSupportValidate,
            trigger: 'change'
          }
        ],
        authtype: [
          {
            required: true,
            message: '请选择授权方式',
            trigger: 'change'
          }
        ],
        machinetype: [
          {
            required: true,
            message: '请选择授权机器',
            trigger: 'change'
          }
        ],
        scope: [
          {
            required: true,
            message: '请选择业务主体',
            trigger: 'change'
          }
        ],
        applytype: [
          {
            required: true,
            message: '请选择申请类型, 测试或正式',
            trigger: 'change'
          }
        ],
        youtucontacts: [
          {
            required: true,
            message: '请输入优图接口人邮箱'
          }, {
            max: 100,
            trigger: 'blur',
            message: '不超过100字'
          }, {
            validator: ErrorHandler.validateMail,
            trigger: ['change', 'blur']
          }
        ],
        intdept: [
          {
            required: true,
            message: '请输入业务所属部门'
          }, {
            max: 100,
            trigger: 'blur',
            message: '不超过100字'
          }, {
            validator: backwardSupportValidate,
            trigger: ['change', 'blur']
          }
        ],
        peercontact: [{
          required: true,
          message: '请输入业务接口人及联系方式',
          trigger: ['change', 'blur']
        }, {
          max: 100,
          trigger: 'blur',
          message: '不超过100字'
        }, {
          validator: backwardSupportValidate,
          trigger: ['change', 'blur']
        }],
        extname: [
          {
            type: 'string',
            required: true,
            message: '请输入公司名称',
            trigger: 'change'
          }, {
            validator: backwardSupportValidate,
            trigger: 'change'
          }
        ],
        ytcontact: [
          {
            type: 'string',
            required: true,
            message: '请输入优图接口人邮箱',
            trigger: ['change', 'blur']
          }, {
            validator: ErrorHandler.validateMail,
            trigger: ['change', 'blur']
          }],
        mailreceiver: [{
          type: 'string',
          required: true,
          message: '请输入业务方邮箱列表',
          trigger: ['change', 'blur']
        }, {
          validator: ErrorHandler.validateMail,
          trigger: ['change', 'blur']
        }],
        exturl: [
          {
            type: 'string',
            required: true,
            message: '请输入公司网址',
            trigger: 'change'
          }, {
            validator: backwardSupportValidate,
            trigger: 'change'
          }
        ]
      },
      privateBlushPalmsSDK: ['YtProduct-1734943355', 'YtProduct-1734943370', 'YtProduct-1734943386'],
      latestID: 0,
      privateTypesConstant: {},
      privateTypesIsOpen: {},
      privateTypesChoosenCount: {},
      allPrivate: {
        options: [],
        value: ''
      }
    };
  },
  methods: {
    handlePrivatetypeChange(val) {
      if (val.length === 1 && val.some(i => this.privateBlushPalmsSDK.includes(i))) {
        this.newPrivateData.authtype = 2;
        this.newPrivateData.machinetype = 1;
      }
      this.bindtypeAppDisabled = false;
      let selectInfo = this.changePrivateTypeToInfo(val);
      for (let key in this.privateTypesConstant) {
        this.$set(this.privateTypesChoosenCount, key, 0);
        this.privateTypesConstant[key].forEach((item) => {
          for (let i = 0; i < selectInfo.length; i++) {
            if (item.id === selectInfo[i].id) {
              this.privateTypesChoosenCount[key] += 1;
            }
          }
        });
      }
    },
    changePrivateTypeToInfo(typelist) {
      let res = [];
      let privateShowsType = [];
      this.allPrivate.options.forEach((item) => {
        if (item.scope !== DISABLED_SDK) {
          privateShowsType.push(item.type);
        }
      });
      typelist.forEach((val) => {
        if (val.type == null) {
          this.allPrivate.options.forEach((item) => {
            if (item.id === val && item.scope !== DISABLED_SDK) {
              res.push(item);
            }
          });
        } else {
          if (val in privateShowsType) {
            res.push(val);
          }
        }
      });
      return res;
    },
    handlePrivateTypesOpen(index) {
      let newV = !this.privateTypesIsOpen[index];
      this.$set(this.privateTypesIsOpen, index, newV);
    },
    getPrivateInfo() {
      if (this.$route.query.id == null || this.$route.query.id === 0) {
        return;
      }
      this.latestID = this.$route.query.id;
      this.$loader.post(api.ytprivate.GET_YTPRIVATE_INFO, {id: this.latestID}, this.ajaxErrorCallback).then((res) => {
        let svctype = [];
        if (res.productids && res.productids.length > 0) {
          res.productids.forEach((val) => {
            this.allPrivate.options.forEach((item) => {
              if (item.id === val && item.scope !== DISABLED_SDK) {
                svctype.push(item.id);
              }
            });
          });
          this.handlePrivatetypeChange(svctype);
        }
        this.newPrivateData = {
          productids: svctype,
          scene: res.scene,
          authtype: res.authtype,
          machinetype: res.machinetype,
          scope: res.scope,
          applytype: res.applytype,
          ytcontact: res.ytcontact == null ? res.ytcontact : res.ytcontact.replace(/,/g, ';'),
          intdept: res.intdept,
          peercontact: res.peercontact,
          exturl: res.exturl,
          extname: res.extname,
          mailreceiver: res.mailreceiver == null ? res.mailreceiver : res.mailreceiver.replace(/,/g, ';')
        };
      });
    },
    handleValidateUploadResultLicence(data, noValidate) {
      let classItems = this.$refs.licence.$el.classList;
      this.handleValidateUploadResult(data, classItems, noValidate, this.validateLicenceFileResult);
    },
    handleValidateUploadResultContract(data, noValidate) {
      let classItems = this.$refs.contract.$el.classList;
      this.handleValidateUploadResult(data, classItems, noValidate, this.validateContractFileResult);
    },
    handleValidateUploadResult(data, classItems, noValidate, filesResult) {
      if (data.result === true || data.file != null) {
        classItems.add(IS_SUCCESS);
        classItems.remove(IS_ERROR);
        filesResult.legal = data.result;
        filesResult.file = data.file;
        return;
      }
      if (noValidate) {
        classItems.remove(IS_ERROR);
        classItems.remove(IS_SUCCESS);
        filesResult.file = null;
        filesResult.legal = false;
        return;
      }
      classItems.add(IS_ERROR);
      classItems.remove(IS_SUCCESS);
      filesResult.file = null;
      filesResult.legal = false;
    },
    changeUploadClass(classItems, uploadError) {
      if (uploadError.length > 0) {
        classItems.add(IS_ERROR);
        classItems.remove(IS_SUCCESS);
        return;
      }
      classItems.add(IS_SUCCESS);
      classItems.remove(IS_ERROR);
    },
    handleSubmitProcess() {
      this.validateFileContract = !(this.validateFileContract);
      // this.validateFileLicence = !(this.validateFileLicence);
      let form = this.$refs.form;
      let files = {};
      // 内部(验证硬件信息)（正式需要验证合作备案）
      if (this.newPrivateData.scope === JoinwayType.INTERNAL) {
        let validateInner = TENCENT_INNER_PROPS.map((fieldName) => {
          return this.wrapperValidate(form, fieldName);
        });
        Promise.all(validateInner).then(() => {
          // 测试
          if (this.newPrivateData.applytype === ApplyType.TEST) {
            this.confirmSubmit(files);
            return;
          }
          // 正式
          if (this.validateContractFileResult.legal === false) {
            return;
          }
          files.contract = this.validateContractFileResult.file;
          this.confirmSubmit(files);
        });
        return;
      }
      // 外部(验证硬件信息，营业执照)（正式需要验证合同）
      let validateExternal = TENCENT_EXTERNAL_PROPS.map((fieldName) => {
        return this.wrapperValidate(form, fieldName);
      });
      files.extlicense = this.validateLicenceFileResult.file;
      Promise.all(validateExternal).then(() => {
        // if (this.validateLicenceFileResult.legal === false) {
        //   return;
        // }
        // 测试
        if (this.newPrivateData.applytype === ApplyType.TEST) {
          this.confirmSubmit(files);
          return;
        }
        // 正式
        if (this.validateContractFileResult.legal === false) {
          return;
        }
        files.contract = this.validateContractFileResult.file;
        this.confirmSubmit(files);
      });
    },
    wrapperValidate(form, fieldName) {
      return new Promise((resolve, reject) => {
        form.validateField(fieldName, function(message) {
          if ((message == null || message.length === 0)) {
            resolve();
            return;
          }
          reject(message);
        });
      });
    },
    confirmSubmit(files) {
      let applyType = this.newPrivateData.applytype;
      this.$confirm(ConfirmMessage[applyType], '提交审核', MessageType.INFO).then(() => {
        const loading = this.loading();
        let data = this.prepareSubmitData();
        this.$loader.upload(api.ytprivate.CREATE_YTPRIVATE, data, files, this.ajaxErrorCallback).then(() => {
          this.$alert('私有云授权已提交审核，审核通过后请绑定设备', null, MessageType.SUCCESS).then(() => {
            loading.close();
            this.$router.transfer(RouteKey.OPEN_PRIVATE_DISPLAY);
          });
        }).finally(() => {
          loading.close();
        });
      });
    },
    prepareSubmitData() {
      let data = {
        ...this.newPrivateData,
        productids: this.newPrivateData.productids.toString()
      };
      data.id = this.latestID;
      data.authtype = str2Int(this.newPrivateData.authtype);
      data.machinetype = str2Int(this.newPrivateData.machinetype);
      data.scope = str2Int(this.newPrivateData.scope);
      data.applytype = str2Int(this.newPrivateData.applytype);
      if (data.mailreceiver.charAt(data.mailreceiver.length - 1) === ';' || data.mailreceiver.charAt(data.mailreceiver.length - 1) === '；') {
        data.mailreceiver = data.mailreceiver.substring(0, data.mailreceiver.length - 1);
      } else {
        data.mailreceiver = data.mailreceiver;
      }
      if (data.ytcontact.charAt(data.ytcontact.length - 1) === ';' || data.ytcontact.charAt(data.ytcontact.length - 1) === '；') {
        data.ytcontact = data.ytcontact.substring(0, data.ytcontact.length - 1);
      } else {
        data.ytcontact = data.ytcontact;
      }
      if (data.scope === JoinwayType.INTERNAL) {
        // data.ytcontact = data.youtucontacts;
        delete data.extname;
        delete data.exturl;
        // delete data.youtucontacts;
        return data;
      }
      delete data.youtucontacts;
      delete data.intdept;
      return data;
    },
    getAllPrivateType() {
      const loading = this.loading();
      this.$loader.get(api.ytbusiness.QUERY_PRODUCT).then((res) => {
        let result = ((res && res.result && res.result.products) || []).filter((item) => {
          return (item.type === SERVICE_TYPE && item.scope === SHOW_SDK_1 && item.online === true && item.display === true);
        });
        result.sort(CompareFunc('order'));
        result.sort(CompareFunc('grouporder'));
        KeyEnum.PrivateGroup.forEach(row => {
          this.$set(this.privateTypesConstant, row.label, result.filter(i => i.property === row.value));
        });
        this.allPrivate.options = result;
        this.getPrivateInfo();
      }).finally(() => {
        loading.close();
      });
    }
  },
  watch: {
    newPrivateData: {
      immediate: true,
      handler(newVal) {
        if (newVal.scope === JoinwayType.INTERNAL) {
          this.defaultExternal = false;
          this.showInnerTable = true;
          this.contractText = Labletext[JoinwayType.INTERNAL];
          this.ErrorNameContract = 'COOPREAT';
        } else {
          this.defaultExternal = true;
          this.showInnerTable = false;
          this.contractText = Labletext[JoinwayType.EXTERNAL];
          this.ErrorNameContract = 'CONTRACT';
        }
      },
      deep: true
    }
  },
  created() {
    this.ajaxErrorCallback = ErrorHandler.ajaxErrorCallback(this);
    this.handleSubmitProcess = this.handleSubmitProcess.bind(this);
    this.getAllPrivateType();
  }
};



// WEBPACK FOOTER //
// ./src/components/open/panels/application/panels/js/PrivateCloudCreator.js